import styled, { css } from 'styled-components';
import { Checkbox } from '@mui/material';

interface IContainerProps {
  $haveError?: boolean;
  $removeMargin?: boolean;
}
export const CustomCheckbox = styled(Checkbox)`
  &&& {
    &.MuiCheckbox-colorSecondary.Mui-checked {
      color: ${({ theme }) => theme.pantone2726C};
    }

    &.Mui-disabled {
      filter: grayscale(1);
      opacity: 0.3;

      &:hover {
        cursor: not-allowed;
      }
    }
  }
`;
export const Container = styled.div<IContainerProps>`
  box-sizing: content-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .MuiCheckbox-colorSecondary.Mui-checked {
    color: ${({ theme }) => theme.pantone2726C};
  }
  .Mui-disabled {
    color: rgba(153, 153, 153, 1);
  }

  /* styles to label */
  .MuiTypography-body1 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ${({ $haveError }) =>
    $haveError &&
    css`
      .MuiFormControl-root {
        margin: 0 0 1rem 0 !important;
      }
    `}

  ${({ $removeMargin }) =>
    $removeMargin &&
    css`
      .MuiFormControlLabel-root {
        margin: 0;
      }
    `}
`;
export const AreaError = styled.div`
  position: absolute;
  bottom: -0.6rem;
  left: -2px;
  width: 400px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  > p {
    margin: 0 0 0 0.4rem;
  }
`;
